<template>
  <div class="page-content">
    <section>
      <div
        class="
          content-wrap previous-wrap
        ">
        <el-button
          type="info"
          icon="
            el-icon-arrow-left
          "
          size="small"
          round
          @click="
            () => fallback()
          ">
          ย้อนกลับ
        </el-button>
      </div>
    </section>

    <section>
      <div
        class="
          filter content-wrap
        ">
        <p>
          <b>
            ค้นหาบ้าน
          </b>
        </p>
        <div class="input-text">
          <input
            v-model="
              search.text
            "
            :placeholder="
              'เลขที่อยู่'
            "
            type="text"
            class="
              el-input__inner
            "
            @keyup.enter="
              () => fetchHome(search.text, 1)
            "
          />
          <el-button
            type="sc-asset"
            icon="
              el-icon-search
            "
            @click="
              () => fetchHome(search.text, 1)
            ">
            ค้นหา
          </el-button>
        </div>
      </div>
    </section>

    <section>
      <div class="content-wrap">
        <div
          class="
            action-panel
          ">
          <div panel="main">
            <p>
              <b>รายการบ้าน</b>
            </p>
            <p>
              พบ <b>{{ paging.total }}</b> รายการ
            </p>
          </div>
          <hr/>
          <div panel="action" class="action-group">
            <el-button
              type="primary"
              icon="
                el-icon-circle-plus
              "
              plain
              @click="
                () => creator.open = true
              ">
              เพิ่มบ้าน
            </el-button>
            <el-button
              type="primary"
              icon="
                el-icon-upload
              "
              plain
              @click="
                () => upload()
              ">
              นำเข้าข้อมูลลูกบ้าน + บ้าน
            </el-button>
            <el-button
              type="primary"
              icon="
                el-icon-upload
              "
              plain
              @click="
                () => uploadHome()
              ">
              นำเข้าข้อมูลเฉพาะบ้าน
            </el-button>
          </div>
        </div>

        <div
          v-if="
            paging.total == 0
          "
          class="empty">
          <img
            src="@/assets/images/admin/empty.png"
          />
          <p>
            <b class="unknown">
              ไม่พบข้อมูล
            </b>
          </p>
        </div>

        <div
          v-if="
            paging.total > 0
          "
          class="
            content-list
          ">
          <div
            v-for="
              (item, i) in home
            "
            :key="i"
            class="item">
            <div
              class="
                item-body
              ">
              <b>
                เลขที่ {{ item.address.addressNo }}
              </b>
              <p
                class="
                  subtitle
                "
                :class="{
                  unknown: !item.structure.name
                }">
                {{ item.structure.name || 'N/A' }}
              </p>
            </div>
            <div
              class="
                item-action
              ">
              <el-button
                type="sc-asset"
                icon="
                  el-icon-edit-outline
                "
                @click="
                  () => open(item.id)
                ">
                เปิด
              </el-button>
            </div>
          </div>
        </div>

        <div
          v-if="
            paging.total > 0
          ">
          <el-pagination
            :background="true"
            :layout="
              'prev, pager, next'
            "
            :pager-count="
              paging.count
            "
            :current-page="
              paging.page
            "
            :page-size="
              paging.limit
            "
            :total="
              paging.total
            "
            @current-change="
              (page) => fetchHome(
                search.text, page
              )
            "
          />
        </div>

        <NonScHomeEditor
          :mode="
            'create'
          "
          :form="
            creator.form
          "
          :open="
            creator.open
          "
          @submit="
            value => create(value)
          "
          @closed="
            () => creator.open = false
          "
        />
      </div>
    </section>
    
    <NonScAlert
      :open="
        alert.open
      "
      :type="
        alert.type
      "
      :message="
        alert.message
      "
      @closed="
        () => alert.open = false
      "
    />

    <!-- Loader -->
    <div 
      v-loading.fullscreen.lock="loader"
      element-loading-background="rgba(0, 0, 0, 0.4)">
    </div>
    
  </div>
</template>
<script lang="js">

// Common
import {
  NonScCommon as Common
} from '../../common/nonsc.common'

import {
  NonScHomeCommon as HomeCommon
} from '../../common/nonsc-home.common'

// Components
import NonScAlert from '../../components/NonScAlert'
import NonScHomeEditor from '../home/NonScHomeEditor'

// Services
// eslint-disable-next-line import/no-cycle
import { NonScFeature } from '../../feature'

export default {
  components: {
    NonScAlert,
    NonScHomeEditor,
  },
  data() {

    // Init Search
    const search = {
      text: null
    }

    // Init Project
    const project= {
      id    : null,
      code  : null,
      name  : {
        tha: null,
        eng: null
      },
    }
    
    // Init Alert
    const alert = {
      open    : false,
      type    : 'error',
      message : 'null',
    }

    // Init Creator
    const creator = {
      open: false,
      form: {
         ...HomeCommon.input
      }
    }

    // Init Paging
    const paging = {
      page  : 1,
      limit : 10,
      count : 5,
      total : 0,
    }

    return {
      title: 'รายการบ้าน',
      loader: false,
      project,
      home: [],
      creator,
      alert,
      search,
      paging,
    }
  },
  computed: {
    clientProject() {
      return NonScFeature.project
    },
    clientHome() {
      return NonScFeature.home
    },
    projectId(){
      return this.$route.params.projectId
    },
    projectName() {

      // Validate Project
      if (!this.project) return undefined

      // Project Props
      const { name } = this.project

      // Set Project Name
      if (name) {
        return `โครงการ${name.tha}`
      }
      return undefined
    },
  },
  watch: {
    projectName(name) {
      if (name) {
        this.$emit(
          'sub-title', `${this.title}${name}`
        )
      }
    }
  },
  mounted() {

    // Set Sub Title
    this.$emit(
      'sub-title', this.title
    )

    // Fallback
    if (!this.projectId) this.fallback()

    // Fetch Project
    this.fetchHome(
      this.search.text, 1, false
    )
  },
  methods: {
    upload() {

      // Route Parameters
      const params = {
        projectId: this.projectId
      }

      // Forward Route
      this.$router.push({
        name: 'nonsc-project-home-import', params
      })
    },
    uploadHome() {
      const params = {
        projectId: this.projectId,
        isImportHome: true
      }

      this.$router.push({
        name: 'nonsc-project-home-import', params
      })
    },
    async fetchProject() {
      
      try {

        // Route Params
        const { projectId } = this.$route.params

        // Validate ID
        if (!projectId) {
          throw new Error('Invalid Parameters')
        }
        
        // Fetch Project
        const result = (
          await this.clientProject.get(projectId)
        )
        
        // Validate Result
        if (!result) {
          throw new Error(
            'Fetch Project Failed'
          )
        }

        // Set Project
        this.project = result

        // Project Address
        const address = (
          Common.setLocation(result.address)
        )
        
        // Set Default Address
        this.creator.form = {
           ...HomeCommon.input, ...address
        }
      }
      catch (_) {
        setTimeout(
          this.fallback, 400
        )
      }
    },
    async fetchHome(text = '', page = 1) {
      
      // Loading
      this.loader = true

      try {

        // Validate Project
        if (!this.project.code) {
          await this.fetchProject()
        }
        
        // Project Code
        const projectCode = this.project.code

        // Paging Props
        const { limit } = this.paging

        // Fetch Params
        const params = {
          projectCode, text, page, limit
        }
        
        // Fetch Home
        const { total, items } = (
          await this.clientHome.list(params)
        )

        // Set Home
        this.home = items
        
        // Set Paging
        Object.assign(
          this.paging, { page, total }
        )
      }
      catch (_) {
        
        // Reset Home
        this.home = []
        
        // Reset Paging
        Object.assign(
          this.paging, { page: 1, total: 0 }
        )
      }
      finally {
        setTimeout(
          () => { this.loader = false }, 400
        )
      }
    },
    setPayload(input) {

      // Validate Input
      if (!input) return null

      // Input Props
      const {
        structure,
        addressRoad,
        transferDate,
      } = input

      // Set Area
      const area = (
        Common.area(input.area)
      )

      // Set Address
      const address = (
        Common.setLocation(input)
      )
      
      // Set Address Detail
      Object.assign(
        address, { addressRoad }
      )

      // Create Payload
      return {
        structure, area, address, transferDate
      }
    },
    async create(input) {
      
      // Loading
      this.loader = true

      try {

        // Project Code
        const projectCode = this.project.code

        // Validate Input
        if (!input || !projectCode) return
          
        // Input Props
        const {
          addressNo,
          addressRoad,
          structure,
          transferDate,
        } = input

        // Set Area
        const area = (
          Common.area(input.area)
        )

        // Set Address
        const address = (
          Common.setLocation(input)
        )
        
        // Set Address Detail
        Object.assign(
          address, { addressNo, addressRoad }
        )
 
        // Set Payload
        const payload = {
          projectCode,
          structure,
          area,
          address,
          transferDate
        }

        // Request Create Home
        await this.clientHome.create(payload)
      }
      catch (error) {
        this.notify(
          Common.error(error)
        )
      }
      finally {
        await this.refresh()
      }
    },
    async refresh() {

      // Paging Props
      const { text } = this.search
      const { page } = this.paging

      // Refresh Home
      await this.fetchHome(text, page)
    },
    open(homeId) {

      // Project Props
      const { projectId } = this.$route.params

      // Parameters
      const params = {
        projectId, homeId
      }

      // Forward Route
      this.$router.push({
        name: 'nonsc-project-home-detail', params
      })
    },
    notify(message) {

      // Validate Message
      if (!message) return

      // Set Notice
      const notice = () => (
        Object.assign(
          this.alert, { open: true, message }
        )
      )

      // Set Alert
      setTimeout(notice, 400)
    },
    fallback() {
      this.$router.push({
        name: 'nonsc-project-list'
      })
    }
  }
}

</script>

<style lang="css" scoped>

.previous-wrap {
  display      : flex;
  margin-top   : var(--size-md);
  margin-bottom: 0;
}

section.header {
  background-color  : white;
  padding           : var(--size-lg) 0;
}

section.header .content-wrap {
  padding : 0;
  margin  : 0 auto;
}

.content-wrap {
  flex-direction  : column;
  gap             : var(--size-md);
  background-color: white;
}
.content-wrap.previous-wrap {
  align-items     : flex-start;
  padding         : 0;
  background-color: unset;
}

.filter {
  display         : flex;
  flex-direction  : column;
  gap             : var(--size-xs);
  background-color: white;
}

.input-text {
  flex    : 1;
  display : flex;
  gap     : .75rem;
}

.content-list {
  display              : grid;
  gap                  : var(--size-sm);
  grid-template-columns: repeat(2, 1fr);
  margin               : var(--size-md) 0;
}

.item {
  padding: var(--size-md);
}
.item-body {
  flex: 1;
}
.item-action {
  flex        : none;
  display     : flex;
  align-items : center;
}

.action-group {
  display: flex;
  gap    : var(--size-sm);
}

.action-panel hr {
  display: none;
}

@media screen and (max-width: 1024px) {

  .action-panel hr {
    display: block;
  }
}

@media screen and (max-width: 640px) {

  .content-list {
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 480px) {

  .item {
    flex-direction  : column;
    gap             : var(--size-sm);
  }

  .item-action {
    justify-content: flex-end;
  }

  .action-group {
    flex: 1;
  }
}

</style>